exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.field-space{\n  padding-top: 3px;\n  margin-left: -1px;\n  padding-left: 4px;\n  background-color: rgba(14, 87, 99, 0.09);\n}\n.form-label {\n  font-size: 11px;\n  font-weight: bold;\n}\n.rowItemInputStyle {\n  padding: 2px;\n  /*padding-bottom: 2px;*/\n}\n.rowLabelInputStyle {\n  padding-top: 1px;\n  padding-bottom: 5px;\n}\n.rowLabelInputStyle svg {\n  margin-top: 8px !important;\n}\n", ""]);

// exports
